// extracted by mini-css-extract-plugin
module.exports = {"fixtureFiles":"fixtureFiles_fixtureFiles__1bCxM","title":"fixtureFiles_title__3Kz8N"};